export const getGridColumnCount = (element) => {
  if (!element) {
    return 1;
  }

  const template = window.getComputedStyle(element).gridTemplateColumns;
  if (!template || template === "none") {
    return 1;
  }

  return template.split(" ").filter(Boolean).length || 1;
};

export const remainingGridSpan = (itemCount, columnCount) => {
  const columns = Math.max(1, columnCount);
  const occupied = itemCount % columns;
  return Math.max(1, columns - occupied);
};
